import type { OwaDate } from '../../../schema';
import { RokuyouDay } from '../../../intl/RokuyouDay';
import convertToLunarCalendarDate from '../lunar/convertToLunarCalendarDate';
import { LunarCalendarType } from '../lunar/LunarCalendarType';

const rokuyouDays: RokuyouDay[] = [
    RokuyouDay.Senshou,
    RokuyouDay.Tomobiki,
    RokuyouDay.Sakimake,
    RokuyouDay.Butsumetsu,
    RokuyouDay.Taian,
    RokuyouDay.Shakku,
];

// The Rokuyou calendar consists of a set of 6 days which cycle thru
// as the month progresses.  In the first month, the first day is
// Senshou, the next Tomobiki, all the way up to the sixth day,
// Shakku.  The 7th day starts over at Senshou.  In the second month,
// the first day starts at Tomobiki and goes from there.  The third month,
// Sakimake and so on.  The happens for the first 6 months, and on month 7,
// the cycle starts over again with the first day being Senshou.  The can be
// expressed as the month plus the day - adjusted for zero-origin indexing -
// modulus 6 and then referencing the list of days.
export default function getRokuyouDay(date: OwaDate): RokuyouDay | undefined {
    const lunarDate = convertToLunarCalendarDate(date, LunarCalendarType.Japanese);

    if (!lunarDate) {
        return undefined;
    }

    const dayIndex = (lunarDate.month + lunarDate.day - 1) % 6;

    return rokuyouDays[dayIndex];
}
